import { render, staticRenderFns } from "./Add_material.vue?vue&type=template&id=1e80e69a&"
import script from "./Add_material.vue?vue&type=script&lang=js&"
export * from "./Add_material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports